import { apiClient } from './client'

export type SiteLinks = {
  lien_husqvarna: string
  lien_honda: string
  lien_miimo: string
  lien_automower: string
}

export async function getSiteLinks(): Promise<SiteLinks> {
  const { data } = await apiClient.get<SiteLinks>('/api/site/links')
  return data
}

export async function updateSiteLinks(links: Partial<SiteLinks>): Promise<void> {
  await apiClient.put('/api/site/links', links)
}
